<template>
    <div class="product-card">
        <div class="product-card-top">
            <a :href="postUrl" class="product-image">
                <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="product image">
            </a>
        </div>

        <div class="product-card-middle">
<!--            <PostRating :ratingPercent="post.rating_percent" :reviewCount="post.reviews.length"/>-->

            <a :href="postUrl" class="product-name">
                <h6>{{ post.name }}</h6>
            </a>
            <span class="post-date" v-html="getCreatedDate"></span>
        </div>

        <div class="product-card-bottom">
            <div class="product-main-info">
                <a
                    :href="postUrl"
                    class="btn btn-primary btn-add-to-cart"
                >
                    <i class="las la-eye"></i>
                    {{ $trans('storefront::blog.more_link') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    // import ProductRating from './PostRating.vue';
    import PostCardMixin from '../../mixins/PostCardMixin';

    export default {
        // components: { PostRating },

        mixins: [
            PostCardMixin,
        ],

        props: ['post'],
    };
</script>
